import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyAKHR6dDOS9B2aPZyHp2AD7Te2aS8qevAw",
  authDomain: "bhoomeeawards.firebaseapp.com",
  projectId: "bhoomeeawards",
  storageBucket: "bhoomeeawards.firebasestorage.app",
  messagingSenderId: "995243760629",
  appId: "1:995243760629:web:88975843715b41987e9ebc",
  measurementId: "G-7RD3H0LGM0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics
let analytics = null;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Helper function to track page views
export const logPageView = (pagePath, pageTitle) => {
  if (analytics) {
    logEvent(analytics, 'page_view', {
      page_path: pagePath,
      page_title: pageTitle
    });
  }
};

// Helper function to track custom events
export const logCustomEvent = (eventName, eventParams = {}) => {
  if (analytics) {
    logEvent(analytics, eventName, eventParams);
  }
};

export { analytics };
export default app;
